import { render } from "./leftBar.vue?vue&type=template&id=472f8f80&scoped=true"
import script from "./leftBar.vue?vue&type=script&lang=js"
export * from "./leftBar.vue?vue&type=script&lang=js"

import "./leftBar.vue?vue&type=style&index=0&id=472f8f80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472f8f80"]])

export default __exports__